<template>
	<div>
		<section class="mobile_only delivery_top_banner cat_in_top_banner cover">
			<div class="container"></div>
			<div class="bn_corner"></div>
		</section>
		<section class="contact_page no_banner_page clearfix m-bg-bege">
			<div class="container">
				<div class="contact_main">
					<h1 class="cat_title">{{ page.title }}</h1>
					<div class="delivery_inner">
						<div class="text">שירות המשלוחים שלנו מתרחב, אבל רק נוודא שאנחנו מגיעים עד אליך</div>
						<div class="del_st0 clearfix">
							<form method="POST" novalidate @submit.prevent="submitForm">
								<div class="right form_input">
									<vue-simple-suggest
										ref="streets"
										preventHide="true"
										v-model="address"
										:list="getStreets"
										:class="{ proccessing: loadingStreets }"
										mode="input"
										:debounce="1000"
										value-attribute="name"
										:min-length="3"
										autocomplete="off"
										:controls="{ selectionUp: [38], selectionDown: [40] }"
										display-attribute="name"
										:prevent-submit="true"
										v-validate="{ required: true }"
										placeholder="כתובת מלאה"
										@input="onCityInput"
										@blur="onBlur"
										@select="onSelect"
									>
									</vue-simple-suggest>

									<div class="error_tx" :class="{ hidden: valid }">{{ errorMessage }}</div>
								</div>
								<div class="right submit_bt ease">
									<input type="submit" value="בדיקה" :disabled="this.loadingStreets" />
								</div>
							</form>
						</div>
						<!-- <!deliver1!> -->
						<div class="del_st1" v-if="stage == 1">
							<div class="deliver_img1">
								<img :src="assets + '/layout/deliver1.png'" />
							</div>
						</div>
						<!-- <!deliver2!> -->
						<div class="del_st2" v-if="stage == 2 && citySelected">
							<h2 class="del_title green">
								<span>איזה כיף! אנחנו מגיעים ל</span>
								<span class="bolder" style="font-weight: 900">{{ citySelected }}</span
								>!
							</h2>
							<div class="del_st_tx">
								<img :src="assets + '/layout/deliver2.png'" />

								<div class="bt_border ease">
									<router-link to="/">אפשר להתחיל להזמין</router-link>
								</div>
							</div>
							<hr />
						</div>
						<!-- <!deliver3!> -->
						<div class="del_st3" v-show="stage == 3 && citySelected">
							<h2 class="del_title red sorry">בלב אנחנו קרובים, אבל עם האוטו זה עדיין רחוק לנו!</h2>
							<div class="del_st_tx sorry">
								<img :src="assets + '/layout/deliver3.png'" />
								<div class="text sorry">
									<span
										>מצטערים, אבל אנחנו עדיין לא מגיעים באופן קבוע ל<span
											style="font-weight: 900"
											>{{ citySelected }}</span
										></span
									><br />
									<span
										>אבל אנחנו מוכנים לנסות! בתיאום טלפוני מולנו במספר 03-5162919 נוכל לבדוק
										אפשרויות שילוח עד אלייך</span
									><br />
									<span>ובינתיים, נשמח לשמור על קשר ולעדכן אותך ברגע שאזורי החלוקה שלנו יתרחבו</span>
									<!--  <span>מצטערים, אבל אנחנו עדיין לא מגיעים ל</span>
                    <span style="font-weight:900;">{{citySelected}}</span>.
                    <br />זה יכול להשתנות, ונשמח לעדכן אותך כשזה יקרה.
                  -->
								</div>
							</div>
							<div class="deliver_form3 clearfix" style="position: relative" v-html="form"></div>
							<div class="form_thank" style="display: none">
								<div class="ok-thank">
									<OK />
								</div>
								<b>היי, קיבלנו, תודה!</b>
								<br />ברגע שנגיע לאזור שלך נהיה בקשר :-)
							</div>
							<hr />
						</div>
						<div class="delivery_bottom">
							<h2 class="title">{{ page.acf.bottom_title }}</h2>
							<div class="text" v-html="page.acf.bottom_content"></div>
							<div class="ban_sale_note">
								*אזורי וזמני המשלוח עשויים להשתנות מעת לעת, על פי שיקול דעת החברה. בכפוף ל<a
									:href="terms_page"
									target="_blank"
									>תנאי השימוש</a
								>
								באתר
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="contact_side delivery_side"></div>
		</section>
	</div>
</template>

<script>
	import { mapActions, mapState } from "vuex";
	import OK from "../assets/img/ok.svg";
	import VueSimpleSuggest from "vue-simple-suggest/dist/cjs";
	import axios from "axios";

	export default {
		data() {
			return {
				terms_page: wpData.terms_page,
				homeUrl: wpData.home_url,
				title: "",
				content: "",
				assets: wpData.assets_url,
				form: wpData.delivery_form,
				areas: wpData.shipment_areas,
				city: "",
				citySelected: "",
				stage: 1,
				shippingSlots: [],
				//page: ""
				loadingStreets: false,
				streets: [],
				street_selected: false,
				address: "",
				cityLatLng: false,
				cityBounds: false,
				showAdressError: false,
				valid: true,
				errorMessage: "נא להזין כתובת מלאה, חובה לבחור מתוך הרשימה.",
			};
		},
		mounted() {
			// Fetch allCities JSON
			fetch(homeUrl + "wp-content/themes/carmella/cache/israel-cities.json")
				.then((raw) => raw.json())
				.then((data) => (this.$store.state.allCities = data));

			setTimeout(() => {
				//  wpcf7.initForm(jQuery(".wpcf7-form"));
				$(".wpcf7-form .submit_bt").on("click", function (e) {
					$(".wpcf7-form  .submit_bt").addClass("proccessing");
					$(".wpcf7-form  .submit_bt").addClass("black");
				});
				$(".wpcf7").on("wpcf7invalid", function (e) {
					$(".wpcf7-form  .submit_bt").removeClass("proccessing");
					$(".wpcf7-form  .submit_bt").removeClass("black");
				});
				$(".wpcf7").on("wpcf7submit", function (e) {
					$(".wpcf7-form  .submit_bt").removeClass("proccessing");
					$(".wpcf7-form  .submit_bt").removeClass("black");
				});
				let _this = this;
				document.addEventListener("wpcf7mailsent", function (event) {
					if (event.detail.apiResponse.status == "mail_sent") {
						var $form = document.querySelector(".deliver_form3");
						var $thank = document.querySelector(".form_thank");
						var $sorry = document.querySelectorAll(".sorry");
						$form.setAttribute("style", "display: none");
						$sorry.forEach(function (elem) {
							elem.setAttribute("style", "display: none");
						});
						var submit = document.querySelector(".submit_bt");
						submit.classList.remove("proccessing");
						submit.classList.remove("black");

						$thank.setAttribute("style", "display:block");
						_this.city = "";
					}
				});
			}, 3000);
		},

		watch: {
			citySelected(newValue, oldValue) {
				if (newValue != oldValue) {
					var $form = document.querySelector(".deliver_form3");
					var $thank = document.querySelector(".form_thank");
					$thank.setAttribute("style", "display: none");
					$form.setAttribute("style", "display:block");
					//console.log(newValue);
					document.querySelector('[name="your-city"]').value = newValue;
				}
			},
			street_selected(newv) {
				//console.log(newv);
			},
		},
		methods: {
			...mapActions(["checkCity", "getShipSlots"]),
			onBlur(e) {
        this.$refs.streets.hideList();
        if (!this.street_selected) {
          this.address = "";
        } else {
          const matchedStreet = this.streets.find((v) => v.description === this.address);
          if (!matchedStreet) {
            this.address = "";
          }
        }
        // const $this = this;
        // setTimeout(function(){
        //   if ($this.street_selected) {
        //     $this.address = "";
        //   }
        // }, 500);
			},
			onSelect(value) {
				this.street_selected = value;
				this.$refs.streets.hideList();
			},
			onCityInput() {
				this.citySelected = false;
				this.stage = 1;
				this.valid = true;
			},
			googleAPI_streets() {
				const service = new google.maps.places.AutocompleteService();
				return new Promise((resolve, reject) => {
					service.getPlacePredictions(
						{
							input: this.address,
							componentRestrictions: {
								country: "il",
							},
							////bounds: this.cityBounds,
							// location: this.cityLatLng,
							// radius: 10,
							types: ["route"],
						},
						(predictions, status) => {
							if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
								reject();
							}
							resolve(predictions);
						}
					);
				});
			},
			getStreets() {
				return new Promise((resolve, reject) => {
					this.loadingStreets = true;
					let shipping = false;
					if (this.showOtherAddress) {
						shipping = true;
					}
					this.add_city = false;

					this.googleAPI_streets()
						.then((streets) => {
							// console.log("streets: ", streets);
							this.loadingStreets = false;
							this.streets = streets;
							let output = [];

							streets.forEach((value) => {
								//if (typeof value.terms[1] !== 'undefined' && value.terms[1].value.includes(this.address_city)) {
								//if (typeof value.structured_formatting.secondary_text !== 'undefined' && value.structured_formatting.secondary_text.includes(this.showOtherAddress ? this.shipping_city : this.address_city)) {

								// console.log(value.structured_formatting.secondary_text);
								// console.log(this.address_city);

								output.push({
									name: value.description,
									label: value.description,
									value: value,
								});
								//}
							});
							resolve(output);
						})
						.catch(() => {
							this.loadingStreets = false;
							// console.log("no results");
							reject();
						});
				});
			},
			getCoordinates(city, street, number) {
				return new Promise((resolve, reject) => {
					const saveToUser = !this.shipping_city;
					const url = `${ajaxUrl}?action=getCoordinates&city=${city}&street=${street}&number=${number}`;
					fetch(url)
						.then((raw) => raw.json())
						.then((res) => {
							resolve(res);
						})
						.catch((e) => {
							console.log(e);
							reject(e);
						});
				});
			},
			submitForm() {
				this.$refs.streets.hideList();
				// const ref = this.$refs.streets;
				// setTimeout(function () {
				// 	ref.hideList();
				// }, 220);

				this.$validator.validate().then((result) => {
					if (!result) {
						this.valid = false;
						return;
					}

					this.valid = true;
					this.loadingStreets = true;

          //console.log('steet', this.street_selected);

					try {
						const city = this.street_selected.value.structured_formatting.secondary_text;
						let street = this.street_selected.value.structured_formatting.main_text;

						if (city && street) {
							this.getCoordinates(city, street.replace(/\d/g, ""), street.replace(/\D/g, "")).then(
								(r) => {
									if (r.success) {
										axios({
											method: "POST",
											url: `${ajaxUrl}?action=coc_getSlots&x=${r.coordinates.x}&y=${r.coordinates.y}&address=${this.address}`,
										}).then((res) => {
											this.loadingStreets = false;
											// console.log(res);
											this.citySelected = this.address;
											if (res.data.success) {
												this.stage = 2;
											} else {
												this.stage = 3;
											}
										});
									}
								}
							);
						} else {
							this.valid = false;
							this.loadingStreets = false;
							this.errorMessage = "לא ניתן לאתר כתובת";
						}
					} catch (e) {
						this.valid = false;
						this.loadingStreets = false;
						this.errorMessage = "לא ניתן לאתר כתובת2";
						//jQuery("body").append(e)
					}
				});
				// const ref = this.$refs.citySearch;
				// setTimeout(function () {
				// 	ref.hideList();
				// }, 220);
				// this.$validator.validate().then((result) => {
				// 	if (result) {
				// 		if (this.city.name == "תל אביב - יפו") {
				// 			this.city.name = "תל אביב";
				// 		}
				// 		this.checkCity(this.city.name)
				// 			.then((res) => {
				// 				if (res) {
				// 					this.citySelected = this.city.name;
				//
				// 					this.stage = 2;
				// 				}
				// 			})
				// 			.catch((e) => {
				// 				this.citySelected = this.city.name;
				//
				// 				this.stage = 3;
				// 			});
				// 	}
				// });
			},
		},
		computed: {
			...mapState(["cities", "allCities"]),

			page: function () {
				return wpData.pageData;
			},
			areasText() {
				if (this.areas) {
					let find = this.areas.find((c) => c.shipment_cities == this.city.name);
					if (typeof find != "undefined") {
						return find.text;
					}
					return "";
				}
				return "";
			},
		},
		components: {
			OK,
			VueSimpleSuggest,
		},
	};
</script>
<style>
	.footer {
		margin-top: 0;
	}
	#delivery_select {
		background-color: #ffff !important;
	}
	.vue-simple-suggest.designed .input-wrapper input {
		transition: none !important;
	}
	.vue-simple-suggest.designed.proccessing .input-wrapper input {
		background-image: url("./../assets/img/ajax-loader.gif");
		background-size: 20px;
		background-position: 15px;
		background-repeat: no-repeat;
	}
	.delivery_inner input[type="submit"][disabled] {
		opacity: 0.7;
		cursor: no-drop;
	}
	.delivery_inner .error_tx.hidden {
		display: none;
	}
</style>
